import React, { PureComponent } from 'react';
import { connect } from "react-redux";
import { Text, Title, Notification, ContainerControlSite, ContentSmall } from '@simplybenefits/sb-ui-library';
import List from '@mui/material/List';

import { removeNotification } from '../../actions/notifications.js';

/**
 * Notifications list for Users, Accounts, Advisors etc...
 * @param classes
 * @param notifications
 * @returns {*}
 * @constructor
 */
class NotificationsList extends PureComponent {
    _removeNotification = (notification) => {
        this.props.dispatch(removeNotification(notification.id, this.props.notificationsType));
    };

    render() {
        const { notifications } = this.props;

        return (
            <ContainerControlSite>
                <ContentSmall>
                    <Title title="Notifications" />

                    <List>
                        {
                            notifications.map((notification) => (
                                <Notification key={notification.id} notification={ notification } onClick={ this._removeNotification }/>
                            ))
                        }
                    </List>

                    {
                        notifications.length === 0 &&
                            <Text
                                align="center"
                                mediumLarge
                                display="block"
                            >
                                No results to display
                            </Text>
                    }
                </ContentSmall>

                <span id="notifications-list" />
            </ContainerControlSite>
        );
    }
}

export default (connect()(NotificationsList));